import React from "react";

const Dashbord = () => {
  return <div></div>;
};

export default Dashbord;
